import { render, staticRenderFns } from "./PayslipZipTask.vue?vue&type=template&id=1ab9a0ec&scoped=true&"
import script from "./PayslipZipTask.vue?vue&type=script&lang=js&"
export * from "./PayslipZipTask.vue?vue&type=script&lang=js&"
import style0 from "./PayslipZipTask.vue?vue&type=style&index=0&id=1ab9a0ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab9a0ec",
  null
  
)

export default component.exports